import React from 'react';
import '../css/main-footer.css';

export default class MainFooter extends React.Component {
  render() {
    return (
      <div className="main-footer">
        <div id="nav-container" className='container'>
          <div className="txt row">
            <div className="footer-col col-lg-4">

              <h2><b>Free Consultation</b></h2>

              <p className="text">
                Set up a free consulting session with our sales team to see how 3D printing can dramatically enhance your dental practice and help improve patient care from day one.
                </p>

              <a className="icon-container" tabIndex="0" href="/consult-digital-dentistry/">
                <span className="icon glyphicon glyphicon-earphone" aria-hidden="true"></span>
                <b>Schedule a Call</b>

              </a>

            </div>

            <div className="footer-col col-lg-4">
              <h2><b>Customer Support</b></h2>
              <p className="text">

                Successful printing is crucial to your practice. If you’re experiencing issues, please get in touch. Our customer support team works Monday through Friday, 9AM - 5PM PST.

              </p>


              <a className="icon-container" tabIndex="0" href="https://support.sprintray.com">
                <span className="icon glyphicon glyphicon-earphone" aria-hidden="true"></span>
                <b>Request Assistance</b>


              </a>
 
            </div>

            <div className="footer-col col-lg-4">


              <h2><b>Other Questions?</b></h2>

              <p className="text">
                If you have general questions or business inquiries, we’re available Monday through Friday, 9AM - 6PM PST. We’d love to hear from you. <br /><br />
              </p>

              <a className="icon-container" tabIndex="0" href="tel:1-(800)-914-8004">

                <span className="icon glyphicon glyphicon-earphone" aria-hidden="true"></span>
          
                <b>(800) 914 - 8004</b>
                  
              </a>

            </div>
          </div>
          <hr/>
          <div className="img-holder">
            <img src='/images/SprintRayLogo-White.png' className='sprintray-icon-footer' width="30%" height="auto"></img>
            <p className="copyright">
              Copyright © 2018 SprintRay Inc.
              All rights reserved.
            </p>
          </div>

        </div>
      </div>
      // <div className='main-footer'>
      //   <img src='/images/SprintRayLogo-White.png' className='sprintray-icon-footer'></img>
      // </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/main-footer.js